export const AUTOMATION_IDS = {
  PANEL: 'manage-menu-panel',
  INFO: '',
  RADIO_BUTTONS: {
    container: 'select-menus-radiobuttons',
    radioButtonMain: 'select-menus-radiobutton-main',
    radioButtonCustom: 'select-menus-radiobutton-custom',
  },
};
